import { render } from "./DengueComponent.vue?vue&type=template&id=78ec97b6&scoped=true"
const script = {}

import "./DengueComponent.vue?vue&type=style&index=0&id=78ec97b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ec97b6"]])

export default __exports__